import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';

const startMessage = `
  display: block;
  padding: .5rem;
  background-color: #222222;
  color: #fef24e;
  font-family: Poppins, sans-serif;
  font-size: 3em; 
  font-weight:bold;
`
console.log(
  `%cWelcome to my portfolio`,
  `${startMessage}`
)
console.log(
  '%chttps://www.linkedin.com/in/conor-vanoystaeyen-20478a137/',
  `${startMessage}; font-size: 1.2em`
)

if (process.env.NODE_ENV !== 'production') {
  const axe = require('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
